import { Show, onMount } from "solid-js";
import { loadCms } from "../app";
import { CMS } from "../components/cms/cms";
import { Progress } from "../components/progress";
import { createStore } from "solid-js/store";
import { A, useRouteData } from "@solidjs/router";
import { UserSession } from "../types";
import { SectionHeader } from "../components/section-header";
import { PageLoading } from "../components/page-loading";

type State = {
    isContentReady: boolean;
}
export function Introduction() {
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    const [session, setSession] = createStore<UserSession>({ } as UserSession);
    onMount(async () => {
        const routeData = await useRouteData() as any;
        setSession(routeData.session);
        await loadCms([
            "24th-arc-scholarship-application/introduction::page-body",
            "artist-application::introduction",
            "nav::home", "nav::living-artist-application",
            "living-artist-application/introduction::page-title",
            "button::start"
        ]);
        setState("isContentReady", true);
    });
    return (
        <Show when={state.isContentReady} fallback={<PageLoading />}>
            <SectionHeader>
                <h1>
                    <CMS id="living-artist-application/introduction::page-title">Living Artist Application</CMS>
                </h1>
                <p>
                    <a href="/"><CMS text id="nav::home">Home</CMS></a> / <A href="/introduction"><CMS text id="nav::living-artist-application">Living Artist Application</CMS></A>
                </p>
            </SectionHeader>
            <section class="landing-page">
                <div class="marketing" style="font-size: 1em; font-family:'Raleway-Regular'; padding-bottom: 40px;">
                    <Progress step={0} />
                    <CMS id="artist-application::introduction"></CMS>
                </div>
                <div style="padding: 60px; margin-bottom: -40px;">
                    <h2 style="text-align: center; font-family: 'Impact';">
                        <A class="btn btn-primary" href="/step-1" style="font-size: 2rem;">
                            <CMS text id="button::start">START</CMS> <span class="fa fa-arrow-circle-right pulse" style="margin-left: 20px;"></span>
                        </A>
                    </h2>
                </div>
            </section>
        </Show>
    );
}